import React from "react";
import PageTitle from "../components/PageTitle";
import {
  GoRepoForked,
  GoAlert,
  GoBriefcase,
  GoBlocked,
  GoShieldLock,
} from "react-icons/go";

import ServiziListElement from "../components/ServiziListElement";
function Servizi() {
  return (
    <div>
      <PageTitle title="Servizi" />
      <ul className=" divide-y-[1px] divide-lightbg-100 pl-[5%] pr-[5%]  text-pretty">
        <li>
          <ServiziListElement
            Icon={GoRepoForked}
            Title="Dichiarazione di successione"
            Description="La dichiarazione di successione è un adempimento fiscale obbligatorio per comunicare all'Agenzia delle Entrate i nuovi titolari dei beni del defunto. Va presentata entro 12 mesi dalla morte per determinare le imposte dovute."
          />
        </li>
        <li>
          <ServiziListElement
            Icon={GoBriefcase}
            Title="Consulenze in materia successoria"
            Description="La consulenza in materia successoria è un servizio legale che aiuta a gestire e pianificare l'eredità. Gli esperti forniscono assistenza su testamenti, divisione dei beni, e diritti degli eredi, garantendo il rispetto delle volontà del defunto e delle normative vigenti."
          />
        </li>
        <li>
          <ServiziListElement
            Icon={GoAlert}
            Title="Esame eventuale lesione di legittima"
            Description="La lesione di legittima si verifica quando il defunto priva un erede legittimario della sua quota legittima (o di riserva) o riduce tale quota in modo significativo. Questo può avvenire attraverso il testamento o una donazione. In tali casi, la legge consente di proteggere gli eredi da questa ingiustizia12. Quando si tratta di successione testamentaria, l'azione di riduzione riconosciuta al legittimario si basa sulla dimostrazione della qualità di legittimario e della lesività della disposizione testamentaria o della donazione. Il legittimario deve indicare entro quali limiti sia stata lesa la sua quota di riserva e determinare con esattezza il valore della massa ereditaria e quello della quota di legittima violata."
          />
        </li>
        <li>
          <ServiziListElement
            Icon={GoBlocked}
            Title="Diseredazione"
            Description="La “Diseredazione” è un atto giuridico che esclude un potenziale erede dalla successione testamentaria. In Italia, è limitata dalla “quota di legittima”, una porzione del patrimonio che non può essere negata ai parenti più prossimi, come figli e coniuge."
          />
        </li>
        <li>
          <ServiziListElement
            Icon={GoShieldLock}
            Title="Intangibilità legittima"
            Description="L'intangibilità legittima protegge la quota di eredità riservata per legge agli eredi legittimari, come figli e coniuge. Questo principio impedisce che disposizioni testamentarie possano ridurre tale quota, garantendo così i diritti successori fondamentali."
          />
        </li>
      </ul>
    </div>
  );
}

export default Servizi;
